export default __webpack_public_path__ + "static/media/NavLogo_footer_white.8550ba86.svg";